import ImmutableMap from 'util/ImmutableMap';
import ImmutableSet from 'util/ImmutableSet';

import {DiagramGridCell, DiagramLayout} from './diagramLayoutTypes';

// dwd stands for dynamic warehouse diagram

export const DWD_TABLE_WIDTH = 270; // pixel width of tables in the dwd (excludes vertical gutter size)

export const DWD_TABLE_HEADER_HEIGHT = 32; // pixel height of the header of dwd tables
export const DWD_TABLE_FOOTER_HEIGHT = 30; // pixel height of the footer of dwd tables
export const DWD_TABLE_HEIGHT_PER_ROW = 20; // pixel height of each row (one row per db table column) of dwd tables
export const DWD_MAX_COLLAPSED_COLUMNS_SHOWN = 5; // up to this many columns will be shown for a given dwd table by default

export function dwdHeightOfTableWithNColumns(n: number): number {
  return DWD_TABLE_HEADER_HEIGHT + n * DWD_TABLE_HEIGHT_PER_ROW + DWD_TABLE_FOOTER_HEIGHT;
}

// pixels taken vertically by a dwd table with DWD_MAX_COLLAPSED_COLUMNS_SHOWN rows
export const DWD_MAX_COLLAPSED_TABLE_HEIGHT = dwdHeightOfTableWithNColumns(DWD_MAX_COLLAPSED_COLUMNS_SHOWN);

export const DWD_HORIZONTAL_GUTTER_SIZE = 50; // pixel width of the horizontal spacing between dwd tables
export const DWD_VERTICAL_GUTTER_SIZE = 50; // pixel width of the vertical spacing between dwd tables

export const DWD_RELATIONSHIP_TOOLTIP_HEIGHT = 50; // pixel height of tooltips appearing on relationship click

// To limit performance concerns, only up to this many tables can be added to the diagram in any single
// action (either opening it, or clicking the "Show related tables" button in table headers).
export const DWD_MAXIMUM_NUMBER_TABLES_TO_ADD = 25;

export const BASE_DIAGRAM_LAYOUT: DiagramLayout = {
  tableNameToCell: new ImmutableMap(),
  cellToTableName: new ImmutableMap(),
  verticallyExpandedTables: new ImmutableSet(),
  hoveredRelationship: null,
  relationshipTooltip: null,
};

export const DWD_FOCUS_TABLE_LOCATION: DiagramGridCell = {
  x: 0,
  y: 0,
};
